export enum WholesaleOrderDetailActionTypes {
  WHOLESALE_ORDER_DETAIL_LOAD = "WHOLESALE_ORDER_DETAIL_LOAD",
  WHOLESALE_ORDER_DETAIL_ERROR = "WHOLESALE_ORDER_DETAIL_ERROR",
  WHOLESALE_ORDER_DETAIL_CLEAR_LOADER = "WHOLESALE_ORDER_DETAIL_CLEAR_LOADER",
  WHOLESALE_ORDER_DETAIL_SUCCESS = "WHOLESALE_ORDER_DETAIL_SUCCESS",
  WHOLESALE_ORDER_DETAIL_UPLOADING = "WHOLESALE_ORDER_DETAIL_UPLOADING",
  WHOLESALE_ORDER_DETAIL_CLEAR_ERROR = "WHOLESALE_ORDER_DETAIL_CLEAR_ERROR",
}
